import React from 'react';
import NoPhotosHere from './NoPhotosHere';

/**
 * Shown when a guest opens a gallery link for an event that has been moved to
 * Trash (soft-deleted). Renders the same "No Photos Here" splash as the default
 * page, but with the frame-warning illustration (which carries the grey "?"
 * placeholder). Presentational only — wiring into the gallery route happens in
 * S18 (PB-9224).
 *
 * @returns {JSX.Element}
 */
export const EventUnavailable = () => <NoPhotosHere image="/static/frame-warning.svg" />;

export default EventUnavailable;
